import { render, staticRenderFns } from "./OneTrustCookiePage.vue?vue&type=template&id=4a3683c7&"
import script from "./OneTrustCookiePage.vue?vue&type=script&lang=js&"
export * from "./OneTrustCookiePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports